angular.module('MktzapApp.Directives')

    .directive('lastMessageCustomer', function () {
        return {
            restrict: 'AE',
            templateUrl: baseUrl + '/templates/directives/lastMessageCustomer.html',
            scope: {
                modelField: '=',
                buttonTitle: '=',
                buttonHint: '=',
            }
        };

    });